function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { NestWatcher } from '../../../models/nest-watcher';
import { FormNodeType } from '../types';
export function getRelativeKeys(node) {
  return node.getPathKeys(function (node) {
    var _node$getValue = node.getValue(),
        type = _node$getValue.type,
        repeat = _node$getValue.repeat,
        field = _node$getValue.field;

    if (type === FormNodeType.ROOT) {
      return null;
    }

    if (node.parentNode && repeat) {
      return String(node.parentNode.getIndex(node));
    }

    return field !== '' ? field : null;
  });
}
export function getNestCachePath(node) {
  var res = [];
  var found = false;
  node.getPathKeys(function (node) {
    var _node$getValue2 = node.getValue(),
        field = _node$getValue2.field,
        cache = _node$getValue2.cache;

    if (found) {
      return null;
    }

    if (cache != null) {
      found = true;
      return null;
    }

    if (field) {
      res.unshift(field);
    }

    return null;
  });

  if (!found) {
    return [];
  }

  return res;
}
export function getNestWatchPath(node) {
  var res = [];
  node.getPathKeys(function (node) {
    var _node$getValue3 = node.getValue(),
        repeat = _node$getValue3.repeat,
        field = _node$getValue3.field;

    if (node.parentNode && repeat) {
      res = [];
    } else if (field) {
      res.unshift(field);
    }

    return null;
  });
  return res;
}
export function wrapFunction(func) {
  return function () {
    try {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var ret = func.call.apply(func, [null].concat(args));

      if (ret != null && _typeof(ret) === 'object' && typeof ret.then === 'function') {
        return ret;
      }

      return Promise.resolve(ret);
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
export function processRelativeKey(node, key) {
  if (/^\.\//.test(key)) {
    key = key.slice(2);
    var scopeKeys = getRelativeKeys(node);
    return NestWatcher.combineKeys([].concat(_toConsumableArray(scopeKeys), _toConsumableArray(NestWatcher.splitKey(key))));
  }

  if (/^\.\.\//.test(key)) {
    var _scopeKeys = getRelativeKeys(node);

    while (/^\.\.\//.test(key)) {
      _scopeKeys.pop();

      key = key.slice(3);
    }

    return NestWatcher.combineKeys([].concat(_toConsumableArray(_scopeKeys), _toConsumableArray(NestWatcher.splitKey(key))));
  }

  return key;
}
export function processNestWatcherKey(node, key) {
  if (/^\.\//.test(key)) {
    return NestWatcher.combineKeys(getNestWatchPath(node));
  }

  if (/^\.\.\//.test(key)) {
    var scopeKeys = getRelativeKeys(node);
    var nestKeys = getNestWatchPath(node);

    while (/^\.\.\//.test(key)) {
      key = key.slice(3);
      scopeKeys.pop();
    }

    return NestWatcher.combineKeys(scopeKeys.length < nestKeys.length ? scopeKeys : nestKeys);
  }

  return key;
}